export default {
    props: {
        categoryAxisCategoryAxisItemAxisCrossingValue: {
            type: Object | Date | Array,
            kComposite: 'categoryAxis.categoryAxisItem.axisCrossingValue'
        }, 
        categoryAxisCategoryAxisItemCategories: {
            type: Array,
            kComposite: 'categoryAxis.categoryAxisItem.categories'
        }, 
        categoryAxisCategoryAxisItemColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.color'
        }, 
        categoryAxisCategoryAxisItemField: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.field'
        }, 
        categoryAxisCategoryAxisItemJustified: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.justified'
        }, 
        categoryAxisCategoryAxisItemLabelsBackground: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.labels.background'
        }, 
        categoryAxisCategoryAxisItemLabelsBorderColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.color'
        }, 
        categoryAxisCategoryAxisItemLabelsBorderDashType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.dashType'
        }, 
        categoryAxisCategoryAxisItemLabelsBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.labels.border.width'
        }, 
        categoryAxisCategoryAxisItemLabelsColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.labels.color'
        }, 
        categoryAxisCategoryAxisItemLabelsFont: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.labels.font'
        }, 
        categoryAxisCategoryAxisItemLabelsFormat: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.labels.format'
        }, 
        categoryAxisCategoryAxisItemLabelsMargin: {
            type: Number | Object,
            kComposite: 'categoryAxis.categoryAxisItem.labels.margin'
        }, 
        categoryAxisCategoryAxisItemLabelsMirror: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.labels.mirror'
        }, 
        categoryAxisCategoryAxisItemLabelsPadding: {
            type: Number | Object,
            kComposite: 'categoryAxis.categoryAxisItem.labels.padding'
        }, 
        categoryAxisCategoryAxisItemLabelsRotation: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.labels.rotation'
        }, 
        categoryAxisCategoryAxisItemLabelsSkip: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.labels.skip'
        }, 
        categoryAxisCategoryAxisItemLabelsStep: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.labels.step'
        }, 
        categoryAxisCategoryAxisItemLabelsTemplate: {
            type: String | Function,
            kComposite: 'categoryAxis.categoryAxisItem.labels.template'
        }, 
        categoryAxisCategoryAxisItemLabelsVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.labels.visible'
        }, 
        categoryAxisCategoryAxisItemLabelsCulture: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.labels.culture'
        }, 
        categoryAxisCategoryAxisItemLabelsDateFormats: {
            type: Object,
            kComposite: 'categoryAxis.categoryAxisItem.labels.dateFormats'
        }, 
        categoryAxisCategoryAxisItemLineColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.line.color'
        }, 
        categoryAxisCategoryAxisItemLineDashType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.line.dashType'
        }, 
        categoryAxisCategoryAxisItemLineVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.line.visible'
        }, 
        categoryAxisCategoryAxisItemLineWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.line.width'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.color'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesDashType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.dashType'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.visible'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.width'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesStep: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.step'
        }, 
        categoryAxisCategoryAxisItemMajorGridLinesSkip: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.majorGridLines.skip'
        }, 
        categoryAxisCategoryAxisItemMajorTicksSize: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.size'
        }, 
        categoryAxisCategoryAxisItemMajorTicksVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.visible'
        }, 
        categoryAxisCategoryAxisItemMajorTicksColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.color'
        }, 
        categoryAxisCategoryAxisItemMajorTicksWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.width'
        }, 
        categoryAxisCategoryAxisItemMajorTicksStep: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.step'
        }, 
        categoryAxisCategoryAxisItemMajorTicksSkip: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.majorTicks.skip'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.color'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesDashType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.dashType'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.visible'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.width'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesStep: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.step'
        }, 
        categoryAxisCategoryAxisItemMinorGridLinesSkip: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.minorGridLines.skip'
        }, 
        categoryAxisCategoryAxisItemMinorTicksSize: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.size'
        }, 
        categoryAxisCategoryAxisItemMinorTicksVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.visible'
        }, 
        categoryAxisCategoryAxisItemMinorTicksColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.color'
        }, 
        categoryAxisCategoryAxisItemMinorTicksWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.width'
        }, 
        categoryAxisCategoryAxisItemMinorTicksStep: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.step'
        }, 
        categoryAxisCategoryAxisItemMinorTicksSkip: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.minorTicks.skip'
        }, 
        categoryAxisCategoryAxisItemName: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.name'
        }, 
        categoryAxisCategoryAxisItemPlotBands: {
            type: Array,
            kComposite: 'categoryAxis.categoryAxisItem.plotBands'
        },         categoryAxisCategoryAxisItemReverse: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.reverse'
        }, 
        categoryAxisCategoryAxisItemTitleBackground: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.title.background'
        }, 
        categoryAxisCategoryAxisItemTitleBorderColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.color'
        }, 
        categoryAxisCategoryAxisItemTitleBorderDashType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.dashType'
        }, 
        categoryAxisCategoryAxisItemTitleBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.title.border.width'
        }, 
        categoryAxisCategoryAxisItemTitleColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.title.color'
        }, 
        categoryAxisCategoryAxisItemTitleFont: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.title.font'
        }, 
        categoryAxisCategoryAxisItemTitleMargin: {
            type: Number | Object,
            kComposite: 'categoryAxis.categoryAxisItem.title.margin'
        }, 
        categoryAxisCategoryAxisItemTitlePosition: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.title.position'
        }, 
        categoryAxisCategoryAxisItemTitleRotation: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.title.rotation'
        }, 
        categoryAxisCategoryAxisItemTitleText: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.title.text'
        }, 
        categoryAxisCategoryAxisItemTitleVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.title.visible'
        }, 
        categoryAxisCategoryAxisItemType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.type'
        }, 
        categoryAxisCategoryAxisItemAutoBaseUnitSteps: {
            type: Object,
            kComposite: 'categoryAxis.categoryAxisItem.autoBaseUnitSteps'
        }, 
        categoryAxisCategoryAxisItemBaseUnit: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.baseUnit'
        }, 
        categoryAxisCategoryAxisItemBaseUnitStep: {
            type: Object,
            kComposite: 'categoryAxis.categoryAxisItem.baseUnitStep'
        }, 
        categoryAxisCategoryAxisItemMax: {
            type: Object,
            kComposite: 'categoryAxis.categoryAxisItem.max'
        }, 
        categoryAxisCategoryAxisItemMin: {
            type: Object,
            kComposite: 'categoryAxis.categoryAxisItem.min'
        }, 
        categoryAxisCategoryAxisItemRoundToBaseUnit: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.roundToBaseUnit'
        }, 
        categoryAxisCategoryAxisItemWeekStartDay: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.weekStartDay'
        }, 
        categoryAxisCategoryAxisItemMaxDateGroups: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.maxDateGroups'
        }, 
        categoryAxisCategoryAxisItemVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.visible'
        }, 
        categoryAxisCategoryAxisItemCrosshairColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.color'
        }, 
        categoryAxisCategoryAxisItemCrosshairWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.width'
        }, 
        categoryAxisCategoryAxisItemCrosshairOpacity: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.opacity'
        }, 
        categoryAxisCategoryAxisItemCrosshairDashType: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.dashType'
        }, 
        categoryAxisCategoryAxisItemCrosshairVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.visible'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipBackground: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.background'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.border.color'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.border.width'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.color'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipFont: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.font'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipFormat: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.format'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipPadding: {
            type: Number | Object,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.padding'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.template'
        }, 
        categoryAxisCategoryAxisItemCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.crosshair.tooltip.visible'
        }, 
        categoryAxisCategoryAxisItemNotesPosition: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.position'
        }, 
        categoryAxisCategoryAxisItemNotesIconBackground: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.background'
        }, 
        categoryAxisCategoryAxisItemNotesIconBorderColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.border.color'
        }, 
        categoryAxisCategoryAxisItemNotesIconBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.border.width'
        }, 
        categoryAxisCategoryAxisItemNotesIconSize: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.size'
        }, 
        categoryAxisCategoryAxisItemNotesIconType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.type'
        }, 
        categoryAxisCategoryAxisItemNotesIconVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.notes.icon.visible'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBackground: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.background'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBorderColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.color'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBorderDashType: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.dashType'
        }, 
        categoryAxisCategoryAxisItemNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.border.width'
        }, 
        categoryAxisCategoryAxisItemNotesLabelColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.color'
        }, 
        categoryAxisCategoryAxisItemNotesLabelFont: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.font'
        }, 
        categoryAxisCategoryAxisItemNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.template'
        }, 
        categoryAxisCategoryAxisItemNotesLabelVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.visible'
        }, 
        categoryAxisCategoryAxisItemNotesLabelRotation: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.rotation'
        }, 
        categoryAxisCategoryAxisItemNotesLabelFormat: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.format'
        }, 
        categoryAxisCategoryAxisItemNotesLabelPosition: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.label.position'
        }, 
        categoryAxisCategoryAxisItemNotesLineWidth: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.width'
        }, 
        categoryAxisCategoryAxisItemNotesLineColor: {
            type: String,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.color'
        }, 
        categoryAxisCategoryAxisItemNotesLineLength: {
            type: Number,
            kComposite: 'categoryAxis.categoryAxisItem.notes.line.length'
        }, 
        categoryAxisCategoryAxisItemNotesData: {
            type: Array,
            kComposite: 'categoryAxis.categoryAxisItem.notes.data'
        }    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/CategoryAxis.js